import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HairFallPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Hair Fall</h1>
        <section className="mb-8">
          <p>Hair fall is a common concern affecting both men and women, often caused by various factors including stress, hormonal imbalances, and nutritional deficiencies. Our natural therapies focus on strengthening hair follicles, promoting healthy growth, and preventing excessive hair loss.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal imbalances</li>
            <li>Nutritional deficiencies</li>
            <li>Stress</li>
            <li>Scalp conditions</li>
            <li>Genetic factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Excessive hair shedding</li>
            <li>Thinning hair</li>
            <li>Scalp irritation</li>
            <li>Bald patches</li>
            <li>Weak, brittle hair</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use hair-strengthening herbs, scalp treatments, and lifestyle modifications to address the root cause of hair fall. Our approach focuses on nourishing the scalp, promoting healthy hair growth, and preventing further loss through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Strengthens hair follicles</li>
            <li>Promotes healthy growth</li>
            <li>No harsh chemicals</li>
            <li>Long-term results</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a balanced diet</li>
            <li>Manage stress</li>
            <li>Use gentle hair care products</li>
            <li>Regular scalp care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment stop hair fall?</strong>
            <p>A: Yes, our natural approach can effectively reduce hair fall and promote regrowth.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for all hair types?</strong>
            <p>A: Yes, our treatments are gentle and suitable for all hair types.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see results?</strong>
            <p>A: Many patients notice improvement within a few months of starting treatment.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Restore your hair—book your natural hair care consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default HairFallPage; 